import { useCallback } from 'react';

import { SCREEN, useKioskSession } from '@/lib/kioskSession';
import { HANDOFF_CONTROL } from '@/services/handoff.contract';

import { PAY_CARD_STATE } from '../types';

/**
 * *Request assistance* on a pay-card screen — the KOP-1g control, and the one path it takes.
 *
 * It names {@link HANDOFF_CONTROL.payCardRequestAssistance}, so the entry it raises reads *pay card in person*
 * [KPC-1a scenario *Request assistance sends …*; 0383 row 8], and it lands on see-a-representative (`finish`)
 * [0095; BR-K7]. The same three calls `PayCardScreen`'s `handOffToRecruiter` makes for its footer button —
 * that copy is left in place because `PayCardScreen.tsx` is under a live KPC-1c run; folding it onto this
 * hook is a follow-up, not a second path: both raise the same control through the one idempotent
 * `summonRepresentative`.
 */
export function useRequestPayCardAssistance(): () => void {
  const summonRepresentative = useKioskSession((state) => state.summonRepresentative);
  const setPayCard = useKioskSession((state) => state.setPayCard);
  const goTo = useKioskSession((state) => state.goTo);

  return useCallback(() => {
    summonRepresentative(undefined, HANDOFF_CONTROL.payCardRequestAssistance);
    setPayCard(PAY_CARD_STATE.handedToRecruiter);
    goTo(SCREEN.finish);
  }, [summonRepresentative, setPayCard, goTo]);
}
